import { reactive } from 'vue'

export const processIndicatorState = reactive({
  pending: 0,
  message: ''
})

const ACTION_MESSAGES = {
  saveGeneral: 'Сохраняем изменения…',
  saveCategories: 'Сохраняем изменения…',
  savePage: 'Сохраняем страницу…',
  createCollectionItem: 'Создаём запись…',
  updateCollectionItem: 'Сохраняем изменения…',
  deleteCollectionItem: 'Удаляем запись…',
  deleteCategoryItem: 'Удаляем категорию…',
  reloadDb: 'Обновляем данные…'
}

function begin(action) {
  const message = ACTION_MESSAGES[action.type]
  if (!message) return

  processIndicatorState.pending += 1
  processIndicatorState.message = message
}

function finish(action) {
  if (!ACTION_MESSAGES[action.type]) return

  processIndicatorState.pending = Math.max(0, processIndicatorState.pending - 1)
  if (!processIndicatorState.pending) processIndicatorState.message = ''
}

export default {
  install(app, { store }) {
    app.provide('processIndicatorState', processIndicatorState)

    store.subscribeAction({
      before: begin,
      after: finish,
      error: finish
    })
  }
}
